import SettingsPage from "@pages/profile/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/settings")({
	component: SettingsPage,
	staticData: {
		breadcrumbId: "page.profile.settings.title",
		breadcrumbTitle: "Settings",
	},
});
